import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-entrepreneurship-cell',
    templateUrl: './entrepreneurship-cell.component.html',
    styleUrls: ['./entrepreneurship-cell.component.scss']
})
export class EntrepreneurshipCellComponent implements OnInit {
    src: string = '/assets/pdf/Entreprenurship Cell.pdf';
    title: string = 'Entrepreneurship Cell';

    constructor() { }

    ngOnInit(): void {
    }
}
